import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
// --- Import components
import Logo from "../../Logo/Logo";
// import Preloader from "../../UI/Preloader/Preloader";
import AutocompleteInput from "../AutocompleteInput/AutocompleteInput";
// --- Import images
import { ReactComponent as Close } from "../../../assets/images/icon_close.svg";

import "./MobileHeader.sass";

function MobileHeader({
  closeMobileHeader,
  // optionsList,
  // optionsHasError,
  // optionsError,
  // optionsIsLoading,
}) {
  const component = useRef();
  // --- Function to close options list
  const handleClickOutside = (e) => {
    if (component.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    closeMobileHeader(false);
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="mobile-header__wrapper">
      <article ref={component} className="mobile-header">
        <Logo />
        {/* {optionsIsLoading ? (
          <Preloader
            width="30px"
            height="30px"
            color="#E5E5E5"
            thickness="8px"
            className="products-list__loading"
          />
        ) : (
          <section className="products-list__wrapper">
            <ul className="products-list">
              {optionsList !== null &&
                optionsList.map((item, i) => {
                  return (
                    <li key={i} className="products-list__item">
                      <a
                        href={item.lp_url}
                        rel="noreferrer"
                        target="_blank"
                        className="products-list__item-link"
                      >
                        {item.name}
                      </a>
                    </li>
                  );
                })}
              {optionsHasError && optionsError !== "" && (
                <li className="products-list__item">
                  <span className="products-list__item-link">
                    {optionsError}
                  </span>
                </li>
              )}
            </ul>
          </section>
        )} */}

        <div className="mobile-header__autocomplete-wrapper">
          <AutocompleteInput
            controler="accountStore"
            action="menuSearch"
            showInput
          />
        </div>
        <button
          aria-label="close"
          className="mobile-header__close-btn"
          onClick={closeMobileHeader}
        >
          <Close className="mobile-header__close-icon" />
        </button>
      </article>
    </div>
  );
}

MobileHeader.propTypes = {
  closeMobileHeader: PropTypes.func.isRequired,
  // optionsList: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string)),
  // optionsHasError: PropTypes.bool,
  // optionsError: PropTypes.string,
  // optionsIsLoading: PropTypes.bool,
};
MobileHeader.defaultProps = {
  // optionsList: null,
  // optionsHasError: false,
  // optionsError: "",
  // optionsIsLoading: false,
};

export default MobileHeader;
